module.exports = __webpack_public_path__ + "static/media/loginPlaceholder.73177fe7.jfif";